// extracted by mini-css-extract-plugin
export default {"cvError":"S5-z"};